// const API_URL = "http://localhost:5083/server/api/";
const API_URL = "https://globuscleaningservices.co.uk/server/api/";

export default { API_URL };